import { createSlice } from "@reduxjs/toolkit";
import { initialFilter } from "../../pages/holidays/HolidaysUIHelpers";

const initialHolidaysState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  holidayForEdit: undefined,
  queryParams: initialFilter,
  localizations: [],
  cleanRefFilters: false
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const holidaysSlice = createSlice({
  name: "holidays",
  initialState: initialHolidaysState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    holidayFetched: (state, action) => {
      state.actionsLoading = false;
      state.holidayForEdit = action.payload.holidayForEdit;
      state.error = null;
    },
    holidaysFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    holidayDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    holidayCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
    },
    holidayUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
    },
    // Query Params
    updateQueryParams: (state, action) => {
      state.queryParams = action.payload.queryParams;
    },
    updateQueryParamsAndReset: (state, action) => {
      state.queryParams = action.payload.queryParams;
      state.entities = [];
      state.totalCount = 0;
    },
    localizationsFetched:(state, action) => {
      state.localizations = action.payload.localizations;
    },
    // Clean Filter
    setValueCleanRefFilter: (state, action) => {
      state.cleanRefFilters= action.payload.flag;
      state.queryParams = action.payload.queryParams;
      state.entities = [];
      state.totalCount = 0;
    },
    endCleanRefFilter: (state, action) => {
      state.cleanRefFilters= action.payload.flag;
    },
  }
});
